import { policy, policyCopy } from './policies'
import { salon } from './content'
import { giftTiers } from './gifts'
import { euro } from '../core/format/currency'
import { lowerFirst } from '../core/format/text'

export type FaqItem = {
  question: string
  answer: string
}

const buildShopFaq = (): FaqItem[] => [
  {
    question: 'Wat krijg ik er gratis bij?',
    answer: `${giftTiers
      .map((t) => `Vanaf ${euro(t.threshold)}: ${lowerFirst(t.title)}.`)
      .join(' ')} In je winkelmand zie je precies wat je hebt vrijgespeeld.`,
  },
  {
    question: 'Wat als een product toch niet bij mijn huid past?',
    answer: `Dat gebeurt zelden, maar het kan. Stuur binnen ${policy.returnDays} dagen een appje met wat je huid doet. Samen zoeken we een alternatief en ruil je het product om, ook als het al geopend is. Je betaalt alleen een eventueel prijsverschil.`,
  },
  {
    question: 'Hoe werkt het Bewust Abonnement?',
    get answer() {
      const checks = policy.subscription.videoChecksPerYear
      return `Je routine komt automatisch terug op het ritme dat bij jouw flesjes past. Je krijgt er ${policyCopy.subscriptionPerks}, ${checks === 1 ? 'één huidcheck' : `${checks} huidchecks`} per jaar via video en voorrang bij vrijgekomen plekken in de salon. Aanpassen, pauzeren of stoppen kan altijd in één klik.`
    },
  },
  {
    question: 'Hoe snel is mijn bestelling in huis?',
    answer: `Op werkdagen voor ${policy.orderCutoff} besteld betekent de volgende werkdag in huis binnen Nederland. België duurt één dag langer. ${policyCopy.shippingBelow}.`,
  },
  {
    question: 'Zijn de producten geschikt tijdens zwangerschap of borstvoeding?',
    answer:
      'De meeste wel, maar retinol en sommige actieve zuren niet. Twijfel je? App me met je routine en ik kijk mee. Dat kost niets, ook als je nog niets koopt.',
  },
  {
    question: 'Kan ik eerst advies krijgen voordat ik iets koop?',
    answer: `Graag zelfs. Een korte vraag via WhatsApp is gratis. Wil je alles doornemen, boek dan ${policy.consult.name}: een online huidconsult van ${policy.consult.minutes} minuten (${euro(policy.consult.price)}). Dat bedrag verrekenen we volledig met een bestelling vanaf ${euro(policy.consult.creditFrom)}.`,
  },
  {
    question: 'Ik heb rosacea of een andere huidaandoening. Kan ik bij je terecht?',
    answer:
      'Ja. Rosacea, hormonale acne en pigmentatie zie ik dagelijks. Stuur me eerst een appje met een foto en wat je nu gebruikt, dan adviseer ik welke producten wel en niet passen. Bij twijfel over een medische oorzaak verwijs ik je eerlijk door naar je huisarts of dermatoloog.',
  },
]

const buildSalonFaq = (): FaqItem[] => [
  {
    question: 'Het is mijn eerste keer. Wat boek ik?',
    answer:
      'Kies “Mijn eerste behandeling”. Dan nemen we eerst rustig je huid, je routine en je wensen door en stem ik de behandeling daarop af. De eerste behandeling reken je vooraf online af; daarna betaal je gewoon in de salon.',
  },
  {
    question: 'Ik heb geen bevestiging ontvangen. Wat nu?',
    answer:
      'Kijk even in je spambox. Staat hij daar ook niet in? Dan is je afspraak nog niet bevestigd. Stuur me een appje, dan zet ik hem er persoonlijk in.',
  },
  {
    question: 'Do you speak English?',
    answer: `Yes. For English information or appointments, send an e-mail to ${salon.email} or a WhatsApp message and I will get back to you within ${policy.responseHours} hours.`,
  },
]

/**
 * De vragen zelf staan hier; de getallen in de antwoorden komen uit de instellingen.
 * `rebuildFaq()` wordt aangeroepen zodra de instellingen uit de backend binnen zijn.
 */
export const shopFaq: FaqItem[] = []
export const salonFaq: FaqItem[] = []

export function rebuildFaq() {
  shopFaq.splice(0, shopFaq.length, ...buildShopFaq())
  salonFaq.splice(0, salonFaq.length, ...buildSalonFaq())
}

rebuildFaq()
